import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import { CognitoService } from 'src/app/auth/services/cognito.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class SocketService implements OnDestroy {
  private socket: Socket | null = null;
  private connected$ = new BehaviorSubject<boolean>(false);
  private usersUpdated$ = new Subject<any>();
  private platformMessage$ = new Subject<any>();
  private agentTaskComplete$ = new Subject<any>();

  constructor(private cognito: CognitoService) {}

  async connect(): Promise<void> {
    if (this.socket?.connected) return;

    const session = await this.cognito.getSession();
    const token = session?.idToken?.jwtToken;
    if (!token) return;

    const baseUrl = environment.apiNest.replace(/\/+$/, '');

    this.socket = io(`${baseUrl}/notifications`, {
      auth: { token },
      transports: ['websocket'],
    });

    this.socket.on('connect', () => this.connected$.next(true));

    this.socket.on('disconnect', async () => {
      this.connected$.next(false);
      const newSession = await this.cognito.getSession();
      const newToken = newSession?.idToken?.jwtToken;
      if (newToken && this.socket) {
        this.socket.auth = { token: newToken };
      }
    });

    this.socket.on('users:updated', (data: any) => {
      this.usersUpdated$.next(data);
    });

    this.socket.on('platform:message', (data: any) => {
      this.platformMessage$.next(data);
    });

    this.socket.on('agent:task-complete', (data: any) => {
      this.agentTaskComplete$.next(data);
    });
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
    this.connected$.next(false);
  }

  isConnected$(): Observable<boolean> {
    return this.connected$.asObservable();
  }

  onUsersUpdated$(): Observable<any> {
    return this.usersUpdated$.asObservable();
  }

  onPlatformMessage$(): Observable<any> {
    return this.platformMessage$.asObservable();
  }

  onAgentTaskComplete$(): Observable<any> {
    return this.agentTaskComplete$.asObservable();
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
